import React, { useEffect, useState } from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOneSU_NT_MRI_GeneralInformation,
  UpdateSU_NT_MRI_GeneralInformation,
} from "../../../../Redux/Reducers/Submitter/GeneralInformation";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
const GeneralInformation = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      GeneralInformationList: state.GeneralInformation.GeneralInformationList,
      loadingGeneralInformationList:
        state.GeneralInformation.loadingGeneralInformationList,
    };
  });
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [checked, setchecked] = useState(false);
  const getData = async () => {
    const data = await dispatch(
      GetOneSU_NT_MRI_GeneralInformation(
        localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid
      )
    );
    console.log(data, "dataaaaa");

    if (data?.payload) {
      setList([...data.payload]);
      setShow(true);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return !state.loadingacademicQualifications && show ? (
    <>
      <div className="AddEdite">
        <div className="checkbox-container">
          <label className="checkbox-labelG" id="labelG">
            هل سبق وتلقيت دعم من مؤسسة عبد الحميد شومان
          </label>
          {list &&
            list.map((elem, i) => {
              return (
                <label className="checkbox-labelG" key={i}>
                  <input
                    type="checkbox"
                    disabled={props.shouldDisableFields}
                    // value=""
                    checked={elem?.ischecked}
                    onChange={(e) => {
                      dispatch(
                        UpdateSU_NT_MRI_GeneralInformation({
                          generalInformationId: elem?.generalInformationId,
                          typesOfSupportId: elem?.typesOfSupportId,
                          ischecked: e.target.checked,

                          applicationInformationId:
                            elem?.applicationInformationId,
                        })
                      );
                    }}
                  />
                  {elem.sU_ST_MRI_TypesOfSupport?.typesOfSupportName}
                </label>
              );
            })}
        </div>
      </div>
    </>
  ) : (
    ""
  );
};

export default GeneralInformation;
